/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The data-ids used in the Login form.
 */
export const LOGIN_FORM_DATA_IDS = {
  emailField: `Form Field: Email address`,
  signInButton: `Form button: Sign in`,
};

/**
 * The form field ids used in the Login form.
 */
export const LOGIN_FORM_IDS = {
  email: `email-input`,
  login: `login-btn`,
};
